// src/axiosInstance.js
import axios from "axios";
// import dotenv from "dotenv";

// dotenv.config();

// console.log("API URL attuale:", process.env.VUE_APP_API_URL);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
});

// Guardia FormData: l'istanza ha un default Content-Type application/json.
// Con quel default già impostato, axios NON lo sovrascrive per le FormData,
// così l'upload partirebbe come application/json (senza boundary) e il backend
// (multer) non riceverebbe il file. Per ogni request con body FormData rimuoviamo
// il Content-Type: il browser lo imposta da solo a multipart/form-data col boundary.
axiosInstance.interceptors.request.use((config) => {
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    const headers = config.headers;
    if (headers) {
      if (typeof headers.delete === "function") {
        // AxiosHeaders (axios v1): delete è case-insensitive.
        headers.delete("Content-Type");
      } else {
        // Cancella tutte le varianti, inclusa la chiave esatta del default ("Content-type").
        delete headers["Content-Type"];
        delete headers["content-type"];
        delete headers["Content-type"];
      }
    }
  }
  return config;
});

// Interceptor per debug degli errori
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error("Errore Axios:", error.response || error.message);
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
